import React from 'react'
import './footer.scss'

class Footer extends React.Component {
  render() {
    const {footerData} = this.props;

    return (
      <div id="footer-wrapper" className="footer">
        <div className="wrapper">
          <div className="markdown" dangerouslySetInnerHTML={{
              __html: footerData.description.childMarkdownRemark.html,
            }} />
          <div className="markdown contact" dangerouslySetInnerHTML={{
              __html: footerData.contactInformation.childMarkdownRemark.html,
            }} />
        </div>
      </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js